import { useCallback } from 'react';
import { pick } from 'js/utils/ramda.util';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useFormatter } from 'js/hooks/useFormatter';
import { downloadBase64Pdf } from 'js/utils/pdf.util';
import { useGetErrorMessage } from 'js/hooks/server/hooks';

import * as server from './server';
import * as actions from '../../../store/actions';
import { REPORT_TYPES } from '../../../constants';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../../../store';

export const useOnDownloadClick = ({ isLoading, setIsLoading, reportType, transactionId }) => {
    const isMounted = useIsMounted();
    const formatter = useFormatter();
    const dispatch = useDynamicReducerDispatch();
    const getErrorMessage = useGetErrorMessage();
    const { from, until } = useDynamicReducerSelector(pick(['from', 'until']));

    return useCallback(async (event) => {
        event.preventDefault();

        if (isLoading || !isMounted()) {
            return;
        }

        dispatch(actions.setError({ error: '' }));
        setIsLoading(true);

        try {
            const pdf = await server.getTaxReportPdf({
                startDate: from,
                endDate: until,
                reportType,
                transactionId
            });
            const fileName = reportType === REPORT_TYPES.TRANSACTION
                ? `${reportType}_${transactionId}`
                : `${reportType}_${formatter.date(from)}_${formatter.date(until)}`;

            downloadBase64Pdf(fileName, pdf.data?.report);
        } catch (error) {
            const errorMsg = getErrorMessage(error);

            isMounted() && dispatch(actions.setError({ error: errorMsg }));
        } finally {
            isMounted() && setIsLoading(false);
        }
    }, [
        from,
        until,
        dispatch,
        formatter,
        isMounted,
        isLoading,
        reportType,
        setIsLoading,
        transactionId,
        getErrorMessage
    ]);
};
